import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Elenix',
    description: "Elenix is the ERP that shows your business at a glance: today's quotations, who signed in, low stock and security alerts, all on one screen.",
    url: getOrigin(),
    appUrl: 'https://elenix.lovable.app/',
    ogImage: 'https://elenix.cdn.modulify.website/images/elenix-share.jpg'
}
